import 'es6-promise';
import 'isomorphic-fetch';
import * as _ from 'lodash';
import * as actions from './index';
import { IEpiProps } from '../state-helpers/epi-props'
import { ISearchAppState } from '../reducers/index'

const fetch = (contentId: any) => {
    return window.fetch('/api/v1/epi/properties?contentId=' + contentId)
        .then(resp => resp.json());
};

let epiCache = _.memoize(fetch);

export function fetchEpiProps() {
    return (dispatch, getState) => {
        let state = getState() as ISearchAppState;
        const contentId = (window as any).bootstrap.contentId;
        epiCache(contentId)
            .then(data => dispatch(actions.getEpiProps(data.data)))
            .catch(err => dispatch(actions.updateResultsFailure(err)));
    }
}